import httpService from '../httpService';
import { ApiResponse } from '../../types/api';

export async function post<T>(url: string, data?: any): Promise<ApiResponse<T>> {
  const response = await httpService.post<ApiResponse<T>>(url, data);
  return response.data;
}
